import { MealPlanningSections, TargetUri, TrackingActions } from '../../../../types/tracking'
import family from '../assets/family.jpg'
import healthy from '../assets/healthy.jpg'
import menu from '../assets/menu.jpg'
import quick from '../assets/quick.jpg'
import vegetarian from '../assets/vegetarian.jpg'

export const MENU_CAROUSEL = {
  heading: 'What types of meals are on the Gousto menu?',
  subtitle:
    "This is a meal plan that really gets you and makes sure you can enjoy whatever kind of food you're into.",
  categories: [
    {
      id: 'full-menu',
      title: 'The Full Gousto Menu',
      subtitle:
        'From exciting global cuisines to family favourites, you can look forward to your new discoveries and find the perfect meal.',
      ctaText: 'Browse all recipes',
      alt: 'A bowl of green curry with chicken, veggies and brown rice',
      src: menu,
      sectionName: MealPlanningSections.MEAL_TYPES,
      target: TargetUri.MENU,
      action: TrackingActions.CLICK_RECIPE_NAVIGATION,
    },
    {
      id: 'health-hub',
      title: "Gousto's Health Hub Menu",
      subtitle:
        "Trying to hit those health goals? We've got low-calorie, high-protein and gut-boosting options too!",
      alt: 'A dish of Pesto-Crusted Salmon With Cheesy Hasselback Potatoes',
      ctaText: 'Browse healthy recipes',
      src: healthy,
      sectionName: MealPlanningSections.MEAL_TYPES,
      target: TargetUri.CALORIE_CONTROLLED,
      action: TrackingActions.CALORIE_CONTROLLED_HELP,
    },
    {
      id: 'quick-easy',
      title: 'Quick & Easy Gousto Menu',
      subtitle: 'Short on time? Try our 10 Minute Meals. Prepped in 5 or One-Pot Wonder ranges.',
      ctaText: 'Browse quick recipes',
      src: quick,
      alt: 'A bowl of Peri Peri Chicken with Red Pepper Rice',
      sectionName: MealPlanningSections.MEAL_TYPES,
      target: TargetUri.TEN_MINUTE_MEALS,
      action: TrackingActions.SPEEDY_10_MIN_MEALS_HELP,
    },
    {
      id: 'vegetarian',
      title: 'Vegetarian & Vegan Gousto Menu',
      subtitle: "Vegetarian, vegan or flexitarian? We've got fresh plant-based options every week.",
      ctaText: 'Browse veggie recipes',
      alt: 'A bowl of Nutty Three Veg Curry with Sesame',
      src: vegetarian,
      sectionName: MealPlanningSections.MEAL_TYPES,
      target: TargetUri.VEGETARIAN,
      action: TrackingActions.VEG_BOOST_HELP,
    },
    {
      id: 'family-friendly',
      title: 'Family-Friendly Gousto Menu',
      subtitle:
        'Crowd-pleasers the whole family can enjoy, with easy adaptations for picky eaters.',
      alt: 'A family friendly recipe of Creamy Tomato Gnocchi Bake',
      ctaText: 'Browse family recipes',
      src: family,
      sectionName: MealPlanningSections.MEAL_TYPES,
      target: TargetUri.FAMILY,
      action: TrackingActions.EVERYDAY_FAVOURITES_HELP,
    },
  ],
}
